<template>
    <div class="help">
        <t-dialog placement="center" :visible="visible" :footer="false" :onConfirm="close" :onClose="close" class="dialog1">
            <span slot="header">
                求助
                <div class="closeButton" @click="close"></div>
            </span>
            <img src="@/assets/help.png" style="width: 240px;height: 240px;">
            <div class="help-view">扫码描述您的问题</div>
        </t-dialog>
    </div>
</template>
  
<script>

export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Help',
    props: {
        visible:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
        };
    },
    methods: {
        close() {
            this.$emit('update:visible', false)
        },
    }
}
</script>
  
<style lang="scss" scoped></style>
  
<style lang="less">
.help{


.dialog1 {
    .t-dialog__close {
        display: none;
    }

    .t-dialog {
        width: 602px;
        height: 368px;
        border-radius: 4px;
        opacity: 1;
        border: 1px solid #e3e6ea;
        padding: 0;
        padding-bottom: 32px;

        .t-dialog__header {
            height: 57px;
            opacity: 1;
            background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
            border-bottom: 1px solid #f5f5f5;

            .t-dialog__header-content {
                display: block;
                margin-left: 24px;
                position: relative;
            }

            .closeButton {
                background: url('@/assets/icon/button_cleaner-3nosha.svg');
                width: 24px;
                height: 24px;
                content: "  ";
                float: right;
                right: 24px;
                position: relative;
                cursor: pointer;
            }
        }

        .help-view {
            height: 22px;
            opacity: 1;
            color: #333333;
            font-size: 16px;
            font-weight: 500;
            font-family: "Regular";
            text-align: center;
        }

    }
}}
</style>
  